import { useState } from 'react';
import { SnackbarMessageProps } from '../components/SnackbarMessage';

const useSnackbarMessage = () => {
  const [snackbarMessage, setSnackbarMessage] = useState<Omit<SnackbarMessageProps, 'onClose'>>({
    message: '',
    open: false,
    severity: 'success',
  });

  const onClose = () => setSnackbarMessage({ ...snackbarMessage, open: false });

  return {
    onClose,
    setSnackbarMessage,
    snackbarMessage,
  };
};

export { useSnackbarMessage };
